import { DeleteChannelRedirect } from '@/connection/channel/redirects';
import { ChannelRedirect } from '@/micros/homepage/settings/settings-main/components/channel-redirects';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const deleteRedirectReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ redirect }: { redirect: ChannelRedirect }, { rejectWithValue }) => {
      try {
        const res = await DeleteChannelRedirect(redirect);
        return res;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (state.redirects) {
          state.redirects = state.redirects.filter((redirect) => redirect.id !== action.meta.arg.redirect.id);
        }
      },
    }
  );
};

export default deleteRedirectReducer;
